import type { LayoutSpec } from '../../../types/LayoutConfig';

/**
 * True when `layoutId` exists in the user's persisted layout configs for the section.
 * Built-in templates that were removed from the user's config are not considered valid URL targets.
 */
export function isUserLayoutId(
  layoutId: string | undefined,
  userLayoutConfigs: Record<string, LayoutSpec> | undefined
): boolean {
  return (
    layoutId != null &&
    userLayoutConfigs != null &&
    Object.hasOwn(userLayoutConfigs, layoutId) &&
    userLayoutConfigs[layoutId] != null
  );
}
